import React from 'react';
import { Box } from '@mui/material';
import BreadcrumbsContainer from '../../common/breadcurmbs/BreadcrumbsContainer';
import ProcessMasterList from '../../../components/manufacturingmng/process/ProcessMasterList';

const ProcessMasterContainer = () => {
  return (
    <>
      <BreadcrumbsContainer title="기준정보/공정 마스터" icon="settings" />

      <Box sx={{ p: 2 }}>
        <ProcessMasterList />
      </Box>
    </>
  );
};

export default ProcessMasterContainer;
